import {apiStatus} from "../../../shared/enums";
import {fetchPaInfo} from "../../../shared/api-service";

export const inquiryMethods = ([state, setState]) => {

    return {
        getRecords: (payload) => {
            const inquiryDefault = {
                data: null,
                error: null,
            }

            setState(prev => ({
                ...prev,
                status: apiStatus.LOADING,
                bannerProps: {
                    message: null
                },
                inquiry: {
                    ...prev.inquiry,
                    ...inquiryDefault,
                }
            }))
                        
            fetchPaInfo(payload)
            .then(data => {
                setState(prev => {
                    return ({
                        ...prev,
                        status: apiStatus.SUCCESS,
                        inquiry: {
                            ...prev.inquiry,
                            data,
                            error: null,
                        }
                    })
                })
            })
            .catch(error => {
                setState(prev => {
                    return ({
                        ...prev,
                        status: apiStatus.ERROR,
                        data: null,
                        bannerProps: {
                            message: 'System encounter an error. Please try again later.',
                            severity: 'error',
                        },
                        inquiry: {
                            ...prev.inquiry,
                            error: error.response || 'System encounter an error. Please try again later.',
                        }
                    })
                })
            })
        },
        setRootOperation: rootOperation => {
            setState(prev => ({
                ...prev,
                inquiry: {
                    ...prev.inquiry,
                    rootOperation
                }
            }));
        },
        setView: (view, operation) => {
            setState(prev => ({
                ...prev,
                operation,
                inquiry: {
                    ...prev.inquiry,
                    view
                }
            }));
        },
        clearData: () => {
            setState(prev => ({
                ...prev,
                inquiry: {
                    ...prev.inquiry,
                    data: null
                }
            }));
        },
    }
}